import { GetterTree } from "vuex";
import { PantryState, RootState } from "@/types/pantry";
import NativeClient from "@/client/native-client";

const getters: GetterTree<PantryState, RootState> = {
  getTagGroups: (state: PantryState) => {
    return state.tagGroups;
  },
  getSearchRecipes: (state: PantryState) => {
    return state.searchRecipes;
  },
  getRecommendRecipes: (state: PantryState) => {
    return state.recommendRecipes;
  },
  getPantryList: (state: PantryState) => {
    return state.pantryList;
  },
  getPantryVirtualList: (state: PantryState) => {
    const totalCount = (state.pantryVirtualList != null) ? state.pantryVirtualList.totalCount : 0;
    const listCount = (state.pantryVirtualList != null) ? state.pantryVirtualList.pantryList.length : 0;
    return state.pantryVirtualList;
  },
  getPantryDetail: (state: PantryState) => {
    return state.pantryDetail;
  },
  getPantryPlateDetail: (state: PantryState) => {
    return state.pantryPlateDetail;
  },
  getPantryConsumeFoods: (state: PantryState) => {
    return state.pantryConsumeFoods;
  },
  getPantryPlateSettingWeight: (state: PantryState) => {
    return state.pantryPlateSettingWeight;
  },
  getPantryFridgeListInfo: (state: PantryState) => {
    return state.pantryFridgeListInfo;
  },
  getRecognitionCandidateMap: (state: PantryState) => {
    return state.recognitionCandidateMap;
  },
  getPantryFridgeDetail: (state: PantryState) => {
    return state.pantryFridgeDetail;
  },
  getRecipeFoods: (state: PantryState) => {
    return state.recipeFoods;
  },
  getRecipeFoodMap: (state: PantryState) => {
    return state.recipeFoodMap;
  },
  getUsedUpPantryList: (state: PantryState) => {
    return state.usedUpPantryList;
  },
  getRankingFoods: (state: PantryState) => {
    return state.rankingFoods;
  },
  getFavoriteFoods: (state: PantryState) => {
    return state.favotiteFoods;
  },
  getMenuCategories: (state: PantryState) => {
    return state.menuCategoies;
  },
  getPurChasedFoods: (state: PantryState) => {
    return state.purChasedFoods;
  },
  getProducts: (state: PantryState) => {
    return state.products;
  },
  getPlateDeviceMode: (state: PantryState) => {
    return state.plateDeviceMode;
  },
  getFoodRecommendationList: (state: PantryState) => {
    return state.foodRecommendationList;
  },
  getFoodConsumeList: (state: PantryState) => {
    return state.foodConsumeList;
  },
  getFavoriteFood: (state: PantryState) => {
    return state.favoriteFoodStatus;
  },
  getFridgeItemsJudge: (state: PantryState) => {
    return state.fridgeItemsJudge;
  },
  getSaveAddFoodItems: (state: PantryState) => {
    return state.addFoodItems;
  },
  getSaveDeleteFoodItems: (state: PantryState) => {
    return state.deleteFoodItems;
  },
  getCameraImageMap: (state: PantryState) => {
    return state.cameraImageMap;
  },
  getCameraImageUrlMap: (state: PantryState) => {
    return state.cameraImageUrlMap;
  }
};

export default getters;
